import { Failure } from "../../components/ToastNotification/Failure";

export const getFormattedTimeInHours = (time) => {
  if (!time) {
    return 0;
  }
  if (time < 60) {
    return `${time} min`;
  } else {
    let hours = Math.floor(time / 60);
    let minutes = Math.floor(((time % 60) / 60) * 100);
    return `${hours}.${("0" + minutes).slice(-2)} hrs`;
  }
};

/**
 * Converts a given number to time e.g 1hr 50mins
 * @param {*} number
 */
export const getHoursAndMinute = (number) => {
  var minutes = number % 60;
  var hours = Math.floor((number - minutes) / 60);
  var finalHours = hours > 1 ? hours + "hrs" : hours === 0 ? "" : hours + "h";
  var finalMinutes = minutes > 1 ? minutes + "mins" : minutes + "m";
  return finalHours + " " + finalMinutes;
};

const timeZoneOptions = { weekday: "short", month: "short", day: "numeric" };
const timeZoneOptionsMonthDayOnly = { month: "short", day: "numeric" };
const timeZoneOptionsTimeOnly = { hour: "2-digit", minute: "2-digit" };

const formatDateTime_1 = (date, separator) => {
  const _date = new Date(date);
  return _date.toLocaleString("en-US", timeZoneOptionsMonthDayOnly) + separator + _date.toLocaleString("en-US", timeZoneOptionsTimeOnly);
};

export const chartColors = [
  "#EC5569",
  "#2C4BE7",
  "#2D3958",
  "#FDBA4C",
  "#00A085",
  "#AFBDFF",
  "#4CAF50",
  "#BC4B51",
  "#5AC779",
  "#E63950",
  "#00A085"
];

export const colorPalette = [
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },

  /////////// repeated
  { solid: "#2D3958", light: "#2D39583b" },
  { solid: "#2C4BE7", light: "#2C4BE73b" },
  { solid: "#4A65EA", light: "#4A65EA3b" },
  { solid: "#6279EC", light: "#6279EC3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#5B8E7D", light: "#5B8E7D3b" },
  { solid: "#DA45C6", light: "#DA45C63b" },
  { solid: "#E789DA", light: "#E789DA3b" },
  { solid: "#FFC850", light: "#FFC8503b" },
  { solid: "#FFDC64", light: "#FFDC643b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#4CAF50", light: "#4CAF503b" },
  { solid: "#7DB0D9", light: "#7DB0D93b" },
  { solid: "#90CAF9", light: "#90CAF93b" },
  { solid: "#1D83D4", light: "#1D83D43b" },
  { solid: "#2196F3", light: "#2196F33b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" },
  { solid: "#5AC779", light: "#5AC7793b" },
  { solid: "#FFD652", light: "#FFD6523b" },
  { solid: "#FDBA4C", light: "#FDBA4C3b" },
  { solid: "#00A085", light: "#00A0853b" },
  { solid: "#E63950", light: "#E639503b" },
  { solid: "#6e79b1", light: "#6e79b13b" },
  { solid: "#BC4B51", light: "#BC4B513b" },
  { solid: "#5c9290", light: "#5c92903b" },
  { solid: "#AFBDFF", light: "#AFBDFF3b" }
];

export const LearningIcons = {
  "Expectation Management": (
    <svg height="24" viewBox="0 0 64 64" width="24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path d="m31 56h2v2h-2z" />
      <path d="m48.678 48.678h2v2h-2z" transform="matrix(.707 -.707 .707 .707 -20.577 49.678)" />
      <path d="m56 31h2v2h-2z" />
      <path d="m61 25h-7.09a22.547 22.547 0 0 0 -1.465-3.542l5.011-5.012a1 1 0 0 0 0-1.414l-4.243-4.242a30 30 0 1 0 -42.426 42.423l4.242 4.243a1 1 0 0 0 1.414 0l5.012-5.011a22.559 22.559 0 0 0 3.545 1.464v7.091a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7.09a22.559 22.559 0 0 0 3.542-1.464l5.012 5.011a1 1 0 0 0 1.414 0l8.485-8.485a1 1 0 0 0 0-1.414l-5.011-5.012a22.559 22.559 0 0 0 1.467-3.546h7.091a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1zm-48.8-12.8a27.989 27.989 0 0 1 38.874-.69l-1.412 1.412a26 26 0 0 0 -36.74 36.74l-1.412 1.412a27.989 27.989 0 0 1 .69-38.874zm28.285 11.315a12 12 0 0 1 -16.97 16.97 1 1 0 0 0 -1.414 0l-7.764 7.764a24 24 0 0 1 33.912-33.912l-7.764 7.763a1 1 0 0 0 0 1.415zm19.515 13.485h-6.836a1 1 0 0 0 -.964.732 20.49 20.49 0 0 1 -1.861 4.5 1 1 0 0 0 .166 1.2l4.829 4.83-7.07 7.07-4.83-4.829a1 1 0 0 0 -1.2-.166 20.49 20.49 0 0 1 -4.5 1.861 1 1 0 0 0 -.732.964v6.838h-10.002v-6.836a1 1 0 0 0 -.732-.964 20.49 20.49 0 0 1 -4.5-1.861 1 1 0 0 0 -1.2.166l-4.83 4.829-2.828-2.828 9.925-9.924a14 14 0 0 0 19.747-19.749l9.924-9.925 2.828 2.828-4.829 4.83a1 1 0 0 0 -.166 1.2 20.473 20.473 0 0 1 1.861 4.5 1 1 0 0 0 .964.732h6.836z" />
      <path d="m33 28.142v-11.142a1 1 0 0 0 -2 0v11.142a4 4 0 0 0 -2.858 2.858h-7.142a1 1 0 0 0 0 2h7.142a3.992 3.992 0 1 0 4.858-4.858zm-1 5.858a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z" />
      <path d="m32 13a1 1 0 0 1 -1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1 -1 1z" />
      <path d="m42 15.68a1 1 0 0 1 -.865-1.5l1-1.733a1 1 0 0 1 1.732 1l-1 1.733a1 1 0 0 1 -.867.5z" />
      <path d="m22 15.68a1 1 0 0 1 -.867-.5l-1-1.733a1 1 0 0 1 1.732-1l1 1.733a1 1 0 0 1 -.865 1.5z" />
      <path d="m14.679 23a.992.992 0 0 1 -.5-.134l-1.733-1a1 1 0 0 1 1-1.732l1.733 1a1 1 0 0 1 -.5 1.866z" />
      <path d="m12 33h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z" />
      <path d="m12.948 44a1 1 0 0 1 -.5-1.866l1.733-1a1 1 0 1 1 1 1.732l-1.733 1a.992.992 0 0 1 -.5.134z" />
      <path d="m32 42a9.914 9.914 0 0 1 -7.068-2.934 1 1 0 1 1 1.416-1.412 7.995 7.995 0 1 0 11.306-11.306 1 1 0 1 1 1.412-1.416 10 10 0 0 1 -7.066 17.068z" />
    </svg>
  ),
  Mindfulness: (
    <svg height="24" viewBox="-40 0 512 512" width="24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="evenodd">
        <path d="m239.933594 112.46875c-34.847656 0-63.199219 28.347656-63.199219 63.199219 0 34.847656 28.351563 63.199219 63.199219 63.199219s63.199218-28.351563 63.199218-63.199219c0-34.847657-28.351562-63.199219-63.199218-63.199219zm0 96.398438c-18.304688 0-33.199219-14.894532-33.199219-33.199219 0-18.308594 14.894531-33.199219 33.199219-33.199219 18.304687 0 33.199218 14.890625 33.199218 33.199219 0 18.304687-14.894531 33.199219-33.199218 33.199219zm0 0" />
        <path d="m239.933594 94.265625c8.285156 0 15-6.714844 15-15v-16.066406c0-8.285157-6.714844-15-15-15s-15 6.714843-15 15v16.066406c0 8.285156 6.714844 15 15 15zm0 0" />
        <path d="m239.933594 257.066406c-8.285156 0-15 6.714844-15 15v16.066406c0 8.285157 6.714844 15 15 15s15-6.714843 15-15v-16.066406c0-8.285156-6.714844-15-15-15zm0 0" />
        <path d="m336.332031 160.667969c-8.28125 0-15 6.714843-15 15 0 8.28125 6.71875 15 15 15h16.066407c8.285156 0 15-6.71875 15-15 0-8.285157-6.714844-15-15-15zm0 0" />
        <path d="m158.53125 175.667969c0-8.285157-6.714844-15-15-15h-16.0625c-8.285156 0-15 6.714843-15 15 0 8.28125 6.714844 15 15 15h16.0625c8.285156 0 15-6.71875 15-15zm0 0" />
        <path d="m318.703125 118.105469 11.359375-11.359375c5.855469-5.859375 5.855469-15.355469-.003906-21.214844-5.855469-5.855469-15.355469-5.855469-21.210938.003906l-11.359375 11.359375c-5.855469 5.859375-5.855469 15.355469 0 21.214844 5.859375 5.855469 15.355469 5.855469 21.214844-.003906zm0 0" />
        <path d="m161.164062 233.226562-11.359374 11.359376c-5.859376 5.859374-5.855469 15.355468 0 21.214843 5.855468 5.855469 15.355468 5.855469 21.214843 0l11.359375-11.363281c5.855469-5.859375 5.855469-15.355469-.003906-21.210938-5.855469-5.859374-15.355469-5.859374-21.210938 0zm0 0" />
        <path d="m318.703125 233.226562c-5.859375-5.859374-15.355469-5.859374-21.214844 0-5.855469 5.855469-5.855469 15.351563 0 21.210938l11.359375 11.363281c5.867188 5.863281 15.363282 5.847657 21.210938 0 5.859375-5.859375 5.859375-15.355469.003906-21.214843zm0 0" />
        <path d="m161.164062 118.105469c5.867188 5.867187 15.363282 5.851562 21.210938.003906 5.859375-5.859375 5.859375-15.355469.003906-21.214844l-11.359375-11.359375c-5.859375-5.859375-15.355469-5.859375-21.214843-.003906-5.855469 5.859375-5.859376 15.355469 0 21.214844zm0 0" />
        <path d="m431.664062 209.632812c0-191.261718-167.960937-209.632812-196.40625-209.632812-108.625 0-179.023437 94.339844-179.023437 167.898438v26.722656c-8.914063 11.457031-34.382813 44.203125-46.503906 59.789062-6.273438 8.066406-9.730469 18.136719-9.730469 28.355469 0 19.183594 11.507812 36.1875 29.328125 43.324219l13.988281 5.59375 22.660156 63.445312c11.234376 31.464844 41.234376 52.605469 74.648438 52.605469h23.328125l13.226563 52.90625c1.671874 6.675781 7.671874 11.359375 14.554687 11.359375h192.796875c4.707031 0 9.144531-2.210938 11.976562-5.96875 2.835938-3.753906 3.742188-8.625 2.449219-13.152344l-30.636719-107.230468 49.746094-111.933594c9.023438-20.308594 13.597656-41.867188 13.597656-64.082032zm-41.011718 51.898438-51.960938 116.910156c-1.425781 3.214844-1.679687 6.828125-.714844 10.210938l26.671876 93.347656h-161.203126l-13.226562-52.90625c-1.667969-6.675781-7.667969-11.359375-14.550781-11.359375h-35.042969c-20.769531 0-39.414062-13.140625-46.398438-32.695313l-24.933593-69.816406c-1.445313-4.050781-4.5625-7.289062-8.558594-8.882812l-20.261719-8.105469c-10.390625-4.160156-13.640625-16.953125-7.0625-25.402344 12.648438-16.269531 39.820313-51.203125 47.570313-61.167969 3.386719-4.359374 5.253906-9.796874 5.253906-15.3125v-28.453124c0-40.292969 42.6875-137.898438 149.039063-137.898438 23.5625 0 166.390624 14.332031 166.390624 179.632812 0 17.992188-3.703124 35.453126-11.011718 51.898438zm0 0" />
      </g>
    </svg>
  ),
  "Decision Making": (
    <svg height="24" viewBox="1 0 511.9995 511" width="24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path d="m422 106.476562c-5.519531 0-10 4.480469-10 10 0 5.519532 4.480469 10 10 10s10-4.480468 10-10c0-5.519531-4.480469-10-10-10zm0 0" />
      <path d="m90 266.476562c-5.519531 0-10 4.480469-10 10 0 5.519532 4.480469 10 10 10s10-4.480468 10-10c0-5.519531-4.480469-10-10-10zm0 0" />
      <path d="m196 266.476562h-66c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h66c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10zm0 0" />
      <path d="m429.070312 29.40625c-2.859374-2.859375-7.160156-3.714844-10.898437-2.167969-3.734375 1.546875-6.171875 5.195313-6.171875 9.238281v30h-126v-47.71875c0-2.652343-1.054688-5.199218-2.933594-7.074218-14.921875-14.910156-39.210937-14.910156-54.132812 0-1.878906 1.875-2.933594 4.421875-2.933594 7.074218v47.71875h-50c-5.523438 0-10 4.480469-10 10v80c0 5.523438 4.476562 10 10 10h50v60h-126v-30c0-4.042968-2.4375-7.691406-6.171875-9.238281-3.738281-1.542969-8.039063-.691406-10.898437 2.167969l-80 80c-3.90625 3.90625-3.90625 10.238281 0 14.144531l80 80c2.863281 2.863281 7.167968 3.710938 10.898437 2.167969 3.734375-1.550781 6.171875-5.195312 6.171875-9.238281v-30h126v126h-30c-16.542969 0-30 13.457031-30 30v10h-30c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h240c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-30v-10c0-16.542969-13.457031-30-30-30h-30v-126h50c5.523438 0 10-4.480469 10-10v-80c0-5.523438-4.476562-10-10-10h-50v-60h126v30c0 4.042969 2.4375 7.6875 6.171875 9.238281 3.746094 1.546875 8.042969.683594 10.898437-2.167969l80-80c3.90625-3.90625 3.90625-10.238281 0-14.144531zm-183.070312-5.957031c6.050781-3.949219 13.949219-3.949219 20 0v43.027343h-20zm80 459.027343v10h-140v-10c0-5.515624 4.484375-10 10-10h120c5.515625 0 10 4.488282 10 10zm-60-30h-20v-126h20zm60-146h-236c-5.523438 0-10 4.476563-10 10v15.855469l-55.859375-55.855469 55.859375-55.855468v15.855468c0 5.523438 4.476562 10 10 10h236zm-60-80h-20v-60h20zm166-54.140624v-15.859376c0-5.519531-4.476562-10-10-10h-236v-60h236c5.523438 0 10-4.476562 10-10v-15.855468l55.859375 55.855468zm0 0" />
      <path d="m382 106.476562h-66c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h66c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10zm0 0" />
    </svg>
  ),
  Storytelling: (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      height="24"
      viewBox="0 0 512 512"
      width="24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m484.19 166.602c15.3-45.869-17.148-95.971-66.723-98.54-13.918-44.24-65.535-64.998-106.043-43.685-29.41-32.441-81.248-32.566-110.766-.001-40.473-21.295-92.154-.588-106.059 43.738-49.316 2.871-82.156 52.22-66.709 98.49-37.037 29.604-37.112 87.021-.014 116.686-10.306 30.67.82 63.817 25.332 83.006l-51.994 124.872c-5.843 14.036 10.658 26.905 22.844 17.762l109.797-82.367c21.434 10.227 46.06 9.757 66.78-1.058 29.418 32.48 81.252 32.609 110.788.025 40.573 21.343 92.146.499 106.044-43.687 49.718-2.581 81.974-52.809 66.723-98.54 37.051-29.611 37.109-87.043 0-116.701zm-25.873 97.985c-7.361 3.97-10.05 13.2-5.982 20.501 8.38 15.038 7.568 32.641-2.172 47.089-9.627 14.281-25.622 21.528-42.784 19.392-8.218-1.03-15.707 4.804-16.734 13.02-2.056 16.433-12.544 29.919-28.056 36.076-15.526 6.163-32.425 3.535-45.204-7.029-7.134-5.899-17.838-3.974-22.496 3.981-8.172 13.956-22.692 22.287-38.842 22.287-16.156 0-30.68-8.331-38.853-22.287-4.651-7.943-15.348-9.889-22.496-3.981-17.71 14.639-39.749 11.835-53.732 2.564-5.289-3.507-12.212-3.306-17.287.503l-73.643 55.245 35.67-85.668c3.006-7.221-.041-15.54-7.001-19.109-21.537-11.046-31.927-38.809-18.959-62.081 4.071-7.306 1.374-16.534-5.982-20.501-31.579-17.033-31.563-62.244 0-79.267 7.363-3.97 10.049-13.2 5.982-20.501-17.78-31.909 8.127-71.061 44.957-66.48 8.213 1.032 15.706-4.806 16.734-13.02 2.056-16.433 12.544-29.919 28.056-36.076 15.526-6.161 32.425-3.534 45.204 7.03 7.152 5.912 17.848 3.958 22.496-3.981 8.172-13.956 22.693-22.288 38.842-22.288 16.156 0 30.68 8.332 38.852 22.288 4.653 7.944 15.35 9.888 22.496 3.981 12.779-10.561 29.677-13.189 45.206-7.027 15.511 6.156 25.999 19.641 28.054 36.073 1.028 8.217 8.521 14.044 16.734 13.02 36.893-4.595 62.693 34.653 44.957 66.48-4.072 7.306-1.374 16.534 5.981 20.501 14.808 7.987 23.649 22.801 23.649 39.631.002 16.829-8.839 31.646-23.647 39.634z" />
        <path d="m375.937 150.986h-239.852c-8.283 0-14.997 6.715-14.997 14.998s6.714 14.998 14.997 14.998h239.853c8.283 0 14.997-6.715 14.997-14.998-.001-8.284-6.715-14.998-14.998-14.998z" />
        <path d="m136.035 240.972h209.958c8.283 0 14.997-6.715 14.997-14.998s-6.714-14.998-14.997-14.998h-209.958c-8.283 0-14.997 6.715-14.997 14.998s6.714 14.998 14.997 14.998z" />
        <path d="m375.937 271.967h-239.952c-8.283 0-14.997 6.715-14.997 14.998s6.714 14.998 14.997 14.998h239.952c8.283 0 14.997-6.715 14.997-14.998s-6.714-14.998-14.997-14.998z" />
      </g>
    </svg>
  ),
  "Trust & Empowerment": (
    <svg height="24" viewBox="-17 0 512 512.00204" width="24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path d="m471.46875 134.757812c-50.066406-30.011718-77.550781-61.796874-91.785156-83.179687-14.921875-22.40625-18.808594-38.367187-19.042969-39.375-1.394531-7.203125-7.664063-12.203125-15.007813-12.203125h-212.347656c-7.285156 0-13.5625 5.125-15.019531 12.257812-.128906.640626-14.175781 64.574219-110.816406 122.5-5.804688 3.476563-8.640625 10.351563-6.976563 16.910157 1.339844 5.289062 33.351563 130.433593 80.375 208.445312 29.015625 48.125 65.910156 86.023438 85.320313 104.332031 14.234375 13.429688 28.078125 24.875 40.035156 33.101563 18.820313 12.957031 27.996094 14.457031 33.257813 14.457031 5.261718 0 14.433593-1.5 33.257812-14.457031 11.953125-8.226563 25.796875-19.671875 40.035156-33.101563 19.410156-18.308593 56.304688-56.207031 85.316406-104.332031 47.027344-78.011719 79.039063-203.15625 80.378907-208.445312 1.660156-6.558594-1.175781-13.433594-6.980469-16.910157zm-25.636719 20.1875c-3.804687 13.800782-11.210937 39.46875-21.359375 69.117188h-79.402344c-6.746093-46.519531-43.707031-83.375-90.273437-89.960938v-103.445312h79.574219c8.679687 23.324219 35.488281 75.835938 111.460937 124.289062zm-206 160.132813c-41.101562 0-74.632812-32.933594-75.644531-73.796875.078125-.621094.128906-1.25.128906-1.890625 0-.644531-.050781-1.269531-.128906-1.894531 1.011719-40.859375 34.542969-73.796875 75.644531-73.796875 41.734375 0 75.691407 33.953125 75.691407 75.691406 0 41.734375-33.957032 75.6875-75.691407 75.6875zm-95.289062-284.421875h79.597656v103.546875c-46.226563 6.863281-82.835937 43.582031-89.546875 89.859375h-80.148438c-10.148437-29.648438-17.554687-55.316406-21.359374-69.117188 75.972656-48.453124 102.78125-100.964843 111.457031-124.289062zm40.15625 409.109375c-17.695313-16.9375-51.304688-51.871094-77.59375-95.480469-15.734375-26.101562-29.890625-58.496094-41.636719-89.566406h69.125c6.726562 46.394531 43.515625 83.183594 89.910156 89.910156v128.308594c-9.597656-6.519531-23.078125-17.160156-39.804687-33.171875zm187.113281-95.480469c-26.289062 43.609375-59.898438 78.539063-77.59375 95.480469-16.300781 15.605469-29.515625 26.101563-39.058594 32.660156v-127.796875c46.394532-6.726562 83.183594-43.515625 89.910156-89.910156h68.378907c-11.75 31.070312-25.902344 63.464844-41.636719 89.566406zm0 0" />
      <path d="m260.066406 211.164062-33.800781 33.800782-8.832031-10.734375c-5.378906-6.535157-15.035156-7.476563-21.574219-2.097657-6.535156 5.378907-7.476563 15.039063-2.097656 21.578126l19.5625 23.773437c2.746093 3.339844 6.777343 5.363281 11.09375 5.570313.25.011718.496093.019531.746093.019531 4.054688 0 7.957032-1.609375 10.835938-4.492188l45.742188-45.738281c5.988281-5.988281 5.988281-15.691406 0-21.679688-5.984376-5.984374-15.691407-5.984374-21.675782 0zm0 0" />
    </svg>
  ),
  Collaboration: (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      height="24"
      viewBox="0 0 512 512"
      width="24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m509.045 88.657-77.011-77.021c-1.892-1.892-4.459-2.956-7.135-2.956-2.676 0-5.243 1.063-7.135 2.956l-47.254 47.253c-30.045-2.711-59.001 7.599-80.1 28.708l-30.02 30.02-46.453-38.765c-.14-.117-.283-.23-.429-.339-29.795-22.241-61.257-23.423-75.541-22.542l-43.72-43.72c-3.941-3.94-10.329-3.942-14.27 0l-77.021 77.011c-1.893 1.892-2.956 4.459-2.956 7.135s1.063 5.243 2.956 7.136l47.253 47.253c-2.712 30.046 7.601 59.002 28.708 80.11 0 0 74.811 74.783 75.001 74.948l5.019 55.592c.016.181.037.362.064.541 5.339 36.811 26.743 59.885 37.473 69.359v61.833c0 5.573 4.518 10.091 10.091 10.091h8.878c5.573 0 10.091-4.518 10.091-10.091 0-5.163-3.877-9.419-8.878-10.019v-19.757h88.736v19.685h-.644c-5.573 0-10.091 4.518-10.091 10.091s4.518 10.091 10.091 10.091h10.734c5.573 0 10.091-4.518 10.091-10.091v-66.826c23.164-19.325 36.346-47.091 36.346-76.944v-41.376c.659-.431 80.136-84.964 80.136-84.964.259-.276.502-.566.728-.869 22.247-29.803 23.435-61.256 22.552-75.541l43.711-43.72c3.939-3.943 3.939-10.331-.001-14.272zm-421.934-55.001 13.916 13.916-62.746 62.746-13.92-13.92zm6.076 182.969c-17.783-17.783-25.95-42.621-22.407-68.145.435-3.132-.623-6.287-2.86-8.523l-15.369-15.368 62.746-62.746 11.731 11.731c2.192 2.192 5.267 3.253 8.345 2.883 8.387-1.014 37.872-2.692 65.848 18.07l43.649 36.424c-2.85 1.563-5.467 3.649-7.742 6.224-1.346 1.512-5.848 6.991-7.5 15.848-3.014-1.038-6.216-1.582-9.504-1.582-15.824 0-28.697 12.661-28.697 28.224v54.926c-4.465-.52-9.415-.186-13.836.949-.167.042.165-.051 0 0-1.013.316-2.274.745-3.282 1.138l-29.705-29.97c-3.923-3.958-10.312-3.987-14.27-.064s-3.986 10.312-.064 14.27l27.371 27.615c-8.663 13.002-6.551 26-6.551 26zm248.55 132.773c0 25.152-11.788 48.489-32.341 64.027-2.523 1.907-4.005 4.887-4.005 8.049v21.737h-88.736v-16.59c0-3.101-1.425-6.029-3.865-7.941-6.646-5.209-28.68-24.853-33.778-59.337l-7.927-87.802c-.011-.124-.025-.248-.04-.372-1.006-7.87 3.048-13.323 12.049-16.21 3.297-.794 6.337-.432 8.335.132v72.301c0 5.573 4.518 10.091 10.091 10.091s10.091-4.518 10.091-10.091v-147.727c0-10.372 17.023-10.504 17.023 0v106.94c0 5.6 4.75 10.215 10.338 10.078 5.588.137 10.338-4.477 10.338-10.078v-127.848c0-4.882 3.181-11.21 8.855-10.93 5.308.261 8.168 6.253 8.168 10.93v127.848c0 5.6 4.75 10.215 10.338 10.078 5.588.137 10.338-4.477 10.338-10.078v-106.94c0-10.372 17.023-10.504 17.023 0v106.94c0 10.215 14.111 13.787 18.973 4.79 1.074-1.604 1.703-3.532 1.703-5.608v-88.182c0-10.228 17.033-10.353 17.033 0v151.793zm103.113-205.344c1.01 8.361 2.679 37.701-17.91 65.618l-65.022 69.287v-31.973c.56-.366 33.446-32.825 33.446-32.825 3.96-3.921 3.992-10.31.071-14.27-3.92-3.959-10.309-3.993-14.27-.071l-19.247 19.055v-21.269c0-7.558-3.024-14.652-8.536-19.999-5.414-5.219-12.574-8.093-20.161-8.093-3.614 0-7.071.664-10.26 1.863-1.366-4.4-3.823-8.421-7.232-11.737-5.4-5.287-12.576-8.198-20.207-8.198-3.332 0-6.531.568-9.509 1.599-.149-.866-.32-1.726-.536-2.567-1.87-7.402-6.162-13.563-11.785-17.619l30.989-30.989c17.776-17.783 42.611-25.95 68.133-22.405 3.131.437 6.287-.624 8.523-2.86l15.372-15.372 62.75 62.75-11.729 11.731c-2.19 2.191-3.252 5.267-2.88 8.344zm28.879-34.347-62.748-62.748 13.917-13.917 62.743 62.751z" />
        <circle cx="259.871" cy="493.32" r="10" />
      </g>
    </svg>
  ),
  Gratitude: (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      height="24"
      viewBox="0 0 512 512"
      width="24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m458.806 489.859-67.126-123.996-56.017-127.968v-222.895c0-8.284-6.716-15-15-15-26.604 0-50.187 13.122-64.663 33.22-14.476-20.098-38.059-33.22-64.663-33.22-8.284 0-15 6.716-15 15v222.895l-56.017 127.968-67.126 123.996c-2.517 4.648-2.401 10.278.305 14.818 2.705 4.541 7.601 7.323 12.886 7.323h121.809c5.506 0 10.57-3.017 13.191-7.859l54.615-100.887 54.615 100.887c2.621 4.842 7.685 7.859 13.191 7.859h121.809c5.286 0 10.181-2.782 12.886-7.323 2.706-4.54 2.821-10.17.305-14.818zm-94.357-111.391c.167.383.351.758.55 1.126l15.703 29.007h-87.695l-12.522-23.131c-6.181-11.418-9.461-23.856-9.486-35.94v-206.811c0-22.158 14.588-40.974 34.663-47.349v145.664c0 2.07.429 4.118 1.259 6.015zm-58.786-346.154v32.177c-12.932 2.475-24.757 8.084-34.663 16.007v-.835c0-22.158 14.588-40.974 34.663-47.349zm-64.663 47.349v.835c-9.906-7.923-21.731-13.532-34.663-16.007v-32.177c20.075 6.375 34.663 25.191 34.663 47.349zm-93.449 298.805 57.527-131.418c.83-1.897 1.259-3.945 1.259-6.015v-145.665c20.075 6.375 34.663 25.191 34.663 47.349v206.781c-.024 12.114-3.305 24.552-9.486 35.97l-12.522 23.131h-87.695l15.703-29.007c.2-.368.383-.743.551-1.126zm-55.989 103.532 23.494-43.399h87.694l-23.493 43.399zm241.181 0-23.494-43.399h87.694l23.495 43.399z" />
    </svg>
  ),
  "Potential Fulfilling": (
    <svg height="16" viewBox="0 -20 512 511" width="16" xmlns="http://www.w3.org/2000/svg" fill="#fff">
      <g fillRule="evenodd">
        <path d="m418.703125 41.070312c-5.242187-1.730468-10.898437 1.117188-12.628906 6.363282-1.730469 5.242187 1.117187 10.898437 6.359375 12.628906 47.589844 15.707031 79.566406 59.957031 79.566406 110.105469 0 47.273437-28.265625 89.402343-72.011719 107.324219-.003906.003906-.011719.007812-.019531.011718s-.015625.003906-.023438.007813c-13.90625 5.777343-28.257812 8.585937-43.875 8.585937-5.519531 0-10 4.476563-10 10 0 5.523438 4.480469 10 10 10 10.363282 0 20.269532-1.0625 29.886719-3.222656-8.503906 16.761719-24.371093 42.339844-51.253906 67.582031-41.976563 39.410157-119.859375 85.40625-253.023437 81.671875-5.851563-4.414062-22.914063-18.554687-39.777344-44.664062-19.117188-29.59375-41.902344-81.117188-41.902344-158.5 0-77.726563 6.320312-129.992188 19.894531-164.492188 12.632813-32.105468 31.769531-49.800781 62.050781-57.371094 47.023438-11.753906 66.109376-5.671874 73.835938 1.5 7.265625 6.742188 9.414062 19.066407 6.394531 36.640626-4.136719 24.027343-11.027343 38.613281-21.6875 45.898437-10.808593 7.386719-27.464843 8.652344-50.917969 3.867187-9.160156-1.992187-20.507812-5.070312-29.632812-8.042968-5.25-1.714844-10.894531 1.160156-12.605469 6.410156-1.710937 5.25 1.160157 10.894531 6.410157 12.605469 7.277343 2.371093 15.878906 4.804687 23.847656 6.769531.667968 25.675781 6.789062 103.953125 55.546875 139.59375-12.328125 36.957031-8.15625 64.125-7.960938 65.335938.792969 4.910156 5.039063 8.402343 9.859375 8.402343.53125 0 1.066406-.039062 1.609375-.128906 5.453125-.882813 9.15625-6.015625 8.273438-11.46875-.042969-.265625-4.105469-26.761719 9.601562-62.546875.007813-.019531.011719-.042969.019531-.0625.007813-.023438.015626-.039062.023438-.058594 12.324219-33.457031 34.738281-61.664062 66.734375-84.03125 2.554687 19.65625 9.347656 38.515625 20.050781 55.320313 1.90625 2.992187 5.140625 4.628906 8.445313 4.628906 1.835937 0 3.695312-.507813 5.363281-1.566406 4.65625-2.96875 6.027344-9.148438 3.058594-13.808594-11.824219-18.5625-18.074219-40.066406-18.074219-62.191406 0-.007813 0-.011719 0-.015625.007813-50.140625 31.976563-94.382813 79.5625-110.089844 5.242187-1.730469 8.09375-7.386719 6.359375-12.632812-1.730469-5.242188-7.390625-8.089844-12.628906-6.359376-54 17.824219-90.851563 66.984376-93.175782 123.421876-36.890624 23.125-63.585937 52.792968-79.554687 88.378906-34.988281-29.761719-41.664063-90.664063-42.902344-116.183594 23.167969 3.105469 40.511719.164062 53.96875-9.03125 15.640625-10.691406 24.929688-28.894531 30.113281-59.027344 4.242188-24.65625.039063-43.054687-12.5-54.6875-16.742187-15.539062-46.929687-17.582031-92.289062-6.242187-36.691406 9.171875-60.78125 31.238281-75.8125 69.449219-14.519531 36.910156-21.28125 91.503906-21.28125 171.816406 0 82.925781 24.902344 138.445312 45.792969 170.414062 22.976562 35.160156 46.121093 50.410156 47.097656 51.039063 1.523437.992187 3.289063 1.546875 5.105469 1.605469 6.367187.214843 12.667968.320312 18.910156.320312 54.949219-.003906 104.9375-8.242188 148.8125-24.554688 39.363281-14.632812 73.90625-35.746093 102.671875-62.753906 41.070313-38.558594 58.382813-77.75 63.351563-90.824218 48.90625-21.929688 80.257812-70.132813 80.257812-124.042969 0-58.796875-37.492188-110.675781-93.296875-129.097657zm0 0" />
        <path d="m376.070312 54.238281c5.507813 0 10-4.492187 10-10 0-5.507812-4.492187-10-10-10-5.507812 0-10 4.492188-10 10 0 5.507813 4.492188 10 10 10zm0 0" />
      </g>
    </svg>
  ),
  Perception: (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      height="16"
      viewBox="0 0 512 512"
      width="16"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m509.796 326.874c-44.857-87.465-142.483-166.874-253.796-166.874-112.094 0-209.436 80.377-253.796 166.874-2.938 5.729-2.938 12.523 0 18.253 44.857 87.464 142.483 166.873 253.796 166.873 126.04 0 218.947-98.922 253.796-166.874 2.938-5.729 2.938-12.523 0-18.252zm-253.796 145.126c-90.776 0-166.974-60.307-212.956-136 45.473-74.855 121.428-136 212.956-136 91.137 0 167.232 60.735 212.956 136-46.194 76.038-122.697 136-212.956 136zm-249.697-360.828c7.39-8.209 20.037-8.871 28.246-1.48l44.544 40.107c8.208 7.392 8.871 20.037 1.48 28.246-7.391 8.21-20.038 8.87-28.246 1.48l-44.544-40.108c-8.208-7.39-8.871-20.036-1.48-28.245zm229.697-11.172v-80c0-11.045 8.954-20 20-20s20 8.955 20 20v80c0 11.045-8.954 20-20 20s-20-8.955-20-20zm-126.8-44.545c-4.493-10.091.045-21.913 10.136-26.406 10.092-4.493 21.913.045 26.406 10.136l30.587 68.7c4.493 10.09-.045 21.913-10.136 26.406-10.062 4.479-21.898-.014-26.406-10.136zm322.227 122.59c-7.391-8.208-6.729-20.854 1.48-28.246l44.544-40.107c8.208-7.391 20.855-6.729 28.246 1.48 7.391 8.208 6.729 20.854-1.48 28.245l-44.544 40.108c-8.211 7.392-20.856 6.727-28.246-1.48zm-95.757-70.16 30.587-68.7c4.493-10.091 16.315-14.629 26.406-10.136s14.629 16.315 10.136 26.406l-30.587 68.699c-4.513 10.137-16.36 14.609-26.406 10.137-10.09-4.493-14.628-16.315-10.136-26.406zm-79.67 129.865c-54.175 0-98.25 44.075-98.25 98.25s44.075 98.25 98.25 98.25 98.25-44.075 98.25-98.25-44.075-98.25-98.25-98.25zm0 156.5c-32.119 0-58.25-26.131-58.25-58.25s26.131-58.25 58.25-58.25 58.25 26.131 58.25 58.25-26.131 58.25-58.25 58.25z" />
      </g>
    </svg>
  ),
  Pride: (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      height="16"
      viewBox="0 0 512 512"
      width="16"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m329.929 358.794c18.015-5.878 31.071-22.841 31.071-42.794 0-19.556-12.539-36.239-30-42.43v-17.57c0-41.355-33.645-75-75-75s-75 33.645-75 75v17.57c-17.461 6.191-30 22.873-30 42.43 0 19.953 13.056 36.916 31.071 42.794 5.937 35.082 36.432 63.206 73.929 63.206 37.478 0 67.989-28.107 73.929-63.206zm-118.929-102.794c0-24.813 20.187-45 45-45 19.557 0 36.239 12.539 42.43 30h-57.43v15c0 8.271-6.729 15-15 15h-15zm90 90c0 24.935-20.607 46-45 46s-45-21.065-45-46v-15h-15c-8.271 0-15-6.729-15-15s6.729-15 15-15h30c19.557 0 36.239-12.539 42.43-30h32.57v30h15c8.271 0 15 6.729 15 15s-6.729 15-15 15h-15z" />
        <path d="m251.115 150.182 4.885 1.683 4.885-1.683c39.036-13.44 100.115-45.965 100.115-90.182 0-33.084-26.916-60-60-60-17.901 0-33.997 7.881-45 20.354-11.003-12.473-27.099-20.354-45-20.354-33.084 0-60 26.916-60 60 0 43.947 61.022 76.722 100.115 90.182zm-40.115-120.182c16.542 0 30 13.458 30 30h30c0-16.542 13.458-30 30-30s30 13.458 30 30c0 24.302-47.663 49.624-75 60.039-27.346-10.419-75-35.738-75-60.039 0-16.542 13.458-30 30-30z" />
        <path d="m481 286c0-52.531-18.065-101.313-48.737-139.876l21.224 1.857 2.614-29.886-72.15-6.313-6.313 72.151 29.886 2.615 1.832-20.937c26.734 34.114 41.644 76.544 41.644 120.389 0 62.883-30.702 122.669-80.91 159.126-13.659-14.236-32.85-23.126-54.09-23.126h-60-60c-21.24 0-40.431 8.89-54.09 23.126-50.208-36.457-80.91-96.243-80.91-159.126 0-43.845 14.91-86.275 41.645-120.388l1.832 20.937 29.886-2.615-6.313-72.151-72.15 6.313 2.614 29.886 21.224-1.857c-30.583 38.449-48.738 87.195-48.738 139.875 0 75.176 36.984 143.304 94.839 184.529-3.118 8.237-4.839 17.155-4.839 26.471v15h270v-15c0-9.316-1.721-18.234-4.839-26.471 57.911-41.265 94.839-109.42 94.839-184.529zm-327.43 196c6.19-17.461 22.873-30 42.43-30h120c19.557 0 36.239 12.539 42.43 30z" />
      </g>
    </svg>
  ),
  Values: (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 511.681 511.681"
      height="16"
      viewBox="0 0 511.681 511.681"
      width="16"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path d="m168.79 301.681 56.008 210-185.178-210z" />
          <path d="m169.86 271.681h-130.24l85.61-85.61c2.82-2.81 6.63-4.39 10.61-4.39h85.45z" />
        </g>
        <g>
          <path d="m307.27 271.681h-102.86l51.43-90z" />
          <path d="m311.84 301.681-56 210-56-210z" />
        </g>
        <g>
          <path d="m341.82 271.681-51.43-90h85.45c3.98 0 7.79 1.58 10.61 4.39l85.61 85.61z" />
          <path d="m342.89 301.681h129.17l-185.178 210z" />
        </g>
        <g>
          <path d="m255.84 85.532c-8.284 0-15-6.716-15-15v-55.532c0-8.284 6.716-15 15-15s15 6.716 15 15v55.532c0 8.284-6.715 15-15 15z" />
        </g>
        <g>
          <path d="m106.733 116.504-27.766-48.092c-4.143-7.174-1.685-16.348 5.49-20.49 7.174-4.142 16.349-1.685 20.49 5.49l27.766 48.092c4.143 7.174 1.685 16.348-5.49 20.49-7.144 4.125-16.33 1.717-20.49-5.49z" />
        </g>
        <g>
          <path d="m384.458 121.995c-7.175-4.142-9.633-13.316-5.49-20.49l27.766-48.092c4.143-7.175 13.315-9.633 20.49-5.49 7.175 4.142 9.633 13.316 5.49 20.49l-27.766 48.092c-4.155 7.196-13.338 9.62-20.49 5.49z" />
        </g>
      </g>
    </svg>
  ),
  "Communication & Transparency": (
    <svg viewBox="0 -14 512.00001 512" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff">
      <path d="m136.964844 308.234375c4.78125-2.757813 6.417968-8.878906 3.660156-13.660156-2.761719-4.777344-8.878906-6.417969-13.660156-3.660157-4.78125 2.761719-6.421875 8.882813-3.660156 13.660157 2.757812 4.78125 8.878906 6.421875 13.660156 3.660156zm0 0" />
      <path d="m95.984375 377.253906 50.359375 87.230469c10.867188 18.84375 35.3125 25.820313 54.644531 14.644531 19.128907-11.054687 25.703125-35.496094 14.636719-54.640625l-30-51.96875 25.980469-15c4.78125-2.765625 6.421875-8.878906 3.660156-13.660156l-13.003906-22.523437c1.550781-.300782 11.746093-2.300782 191.539062-37.570313 22.226563-1.207031 35.542969-25.515625 24.316407-44.949219l-33.234376-57.5625 21.238282-32.167968c2.085937-3.164063 2.210937-7.230469.316406-10.511719l-20-34.640625c-1.894531-3.28125-5.492188-5.203125-9.261719-4.980469l-38.472656 2.308594-36.894531-63.90625c-5.34375-9.257813-14.917969-14.863281-25.605469-14.996094-.128906-.003906-.253906-.003906-.382813-.003906-10.328124 0-19.703124 5.140625-25.257812 13.832031l-130.632812 166.414062-84.925782 49.03125c-33.402344 19.277344-44.972656 62.128907-25.621094 95.621094 17.679688 30.625 54.953126 42.671875 86.601563 30zm102.324219 57.238282c5.523437 9.554687 2.253906 21.78125-7.328125 27.316406-9.613281 5.558594-21.855469 2.144531-27.316407-7.320313l-50-86.613281 34.640626-20c57.867187 100.242188 49.074218 85.011719 50.003906 86.617188zm-22.683594-79.296876-10-17.320312 17.320312-10 10 17.320312zm196.582031-235.910156 13.820313 23.9375-12.324219 18.664063-23.820313-41.261719zm-104.917969-72.132812c2.683594-4.390625 6.941407-4.84375 8.667969-4.796875 1.707031.019531 5.960938.550781 8.527344 4.996093l116.3125 201.464844c3.789063 6.558594-.816406 14.804688-8.414063 14.992188-1.363281.03125-1.992187.277344-5.484374.929687l-123.035157-213.105469c2.582031-3.320312 2.914063-3.640624 3.425781-4.480468zm-16.734374 21.433594 115.597656 200.222656-174.460938 34.21875-53.046875-91.878906zm-223.851563 268.667968c-4.390625-7.597656-6.710937-16.222656-6.710937-24.949218 0-17.835938 9.585937-34.445313 25.011718-43.351563l77.941406-45 50 86.601563-77.941406 45.003906c-23.878906 13.78125-54.515625 5.570312-68.300781-18.304688zm0 0" />
      <path d="m105.984375 314.574219c-2.761719-4.78125-8.878906-6.421875-13.660156-3.660157l-17.320313 10c-4.773437 2.757813-10.902344 1.113282-13.660156-3.660156-2.761719-4.78125-8.878906-6.421875-13.660156-3.660156s-6.421875 8.878906-3.660156 13.660156c8.230468 14.257813 26.589843 19.285156 40.980468 10.980469l17.320313-10c4.78125-2.761719 6.421875-8.875 3.660156-13.660156zm0 0" />
      <path d="m497.136719 43.746094-55.722657 31.007812c-4.824218 2.6875-6.5625 8.777344-3.875 13.601563 2.679688 4.820312 8.765626 6.566406 13.601563 3.875l55.71875-31.007813c4.828125-2.6875 6.5625-8.777344 3.875-13.601562-2.683594-4.828125-8.773437-6.5625-13.597656-3.875zm0 0" />
      <path d="m491.292969 147.316406-38.636719-10.351562c-5.335938-1.429688-10.820312 1.734375-12.25 7.070312-1.429688 5.335938 1.738281 10.816406 7.074219 12.246094l38.640625 10.351562c5.367187 1.441407 10.824218-1.773437 12.246094-7.070312 1.429687-5.335938-1.738282-10.820312-7.074219-12.246094zm0 0" />
      <path d="m394.199219 7.414062-10.363281 38.640626c-1.429688 5.335937 1.734374 10.816406 7.070312 12.25 5.332031 1.425781 10.816406-1.730469 12.25-7.070313l10.359375-38.640625c1.429687-5.335938-1.734375-10.820312-7.070313-12.25-5.332031-1.429688-10.816406 1.734375-12.246093 7.070312zm0 0" />
    </svg>
  ),
  "Emotional Awareness": (
    <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96">
      <path
        id="Exclusion_1"
        data-name="Exclusion 1"
        d="M48.5,96.5A48.012,48.012,0,0,1,29.816,4.272a47.967,47.967,0,0,1,53.95,11.666,1.438,1.438,0,0,0-.608.163L61.873,27.18A27.139,27.139,0,0,0,38.853,14a28.6,28.6,0,0,0-14.982,4.2,1.451,1.451,0,1,0,1.518,2.473A25.7,25.7,0,0,1,38.853,16.9a23.639,23.639,0,0,1,11.677,3.11,24.652,24.652,0,0,1,8.764,8.51L48.618,34.08a11.265,11.265,0,0,0-10.933-9.458l-.191,0A11.235,11.235,0,0,0,26.241,35.687V49a1.46,1.46,0,0,0,1.041,1.392l12.312,3.617a1.451,1.451,0,0,0,1.278-.231,1.455,1.455,0,0,0,.581-1.161V49.044h1.907a4.322,4.322,0,0,0,4.317-4.317V43.365h1.485a1.451,1.451,0,0,0,1.387-1.876l-.756-2.461L64.5,46.683l2.846,9.266H61.536A1.452,1.452,0,0,0,60.085,57.4v7.448a6.146,6.146,0,0,1-6.139,6.139H45.054a1.447,1.447,0,0,0-1.428,1.2l-1.488,8.522a1.45,1.45,0,0,0,1.179,1.678,1.5,1.5,0,0,0,.251.022A1.446,1.446,0,0,0,45,81.21l1.278-7.321h7.673a9.051,9.051,0,0,0,9.04-9.04v-6H69.31A1.452,1.452,0,0,0,70.7,56.974l-2.584-8.411,15.044,7.832a1.463,1.463,0,0,0,.669.164,1.451,1.451,0,0,0,.671-2.738L50.738,36.248,84.5,18.675a1.441,1.441,0,0,0,.76-1.043A47.983,47.983,0,0,1,48.5,96.5ZM15.628,27.3a1.454,1.454,0,0,0-1.267.741A26.475,26.475,0,0,0,11,40.974,36.794,36.794,0,0,0,14.7,56.82a22.019,22.019,0,0,1,1.748,14.93l-2.138,8.87a1.451,1.451,0,1,0,2.821.68l2.138-8.87a24.922,24.922,0,0,0-1.97-16.9A33.791,33.791,0,0,1,13.9,40.974a23.25,23.25,0,0,1,2.99-11.516A1.45,1.45,0,0,0,15.628,27.3Zm3.906-5.231a1.452,1.452,0,1,0,1.025.425A1.461,1.461,0,0,0,19.535,22.066ZM38.552,50.682h0l-9.409-2.764V35.725a8.368,8.368,0,0,1,8.366-8.2h.13a8.4,8.4,0,0,1,8.221,8.358,1.448,1.448,0,0,0,.064.426L47.2,40.464h-.973a1.452,1.452,0,0,0-1.451,1.45v2.813a1.416,1.416,0,0,1-1.415,1.415H40a1.452,1.452,0,0,0-1.451,1.451V50.68Zm46.706-33.05v0c-.479-.57-.98-1.139-1.49-1.691h.06a1.451,1.451,0,0,1,1.432,1.692Z"
        transform="translate(-0.5 -0.5)"
        fill="#fff"
      />
    </svg>
  ),
  Feedback: (
    <svg
      id="Bold"
      enableBackground="new 0 0 24 24"
      height="16"
      viewBox="0 0 24 24"
      width="16"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m15.367 10.129-.44-2.702 1.86-1.907c.425-.435.181-1.173-.423-1.265l-2.541-.389-1.144-2.436c-.247-.526-1.11-.526-1.357 0l-1.144 2.436-2.541.389c-.606.093-.848.83-.423 1.265l1.86 1.907-.44 2.702c-.101.619.559 1.079 1.103.777l2.263-1.251 2.264 1.251c.54.301 1.205-.154 1.103-.777z" />
      <path d="m10.363 14.255-2.541-.389-1.144-2.436c-.247-.526-1.11-.526-1.357 0l-1.144 2.436-2.541.389c-.606.093-.848.83-.423 1.265l1.86 1.907-.44 2.702c-.101.616.556 1.081 1.103.777l2.264-1.251 2.264 1.251c.54.3 1.205-.154 1.103-.777l-.44-2.702 1.86-1.907c.424-.435.181-1.172-.424-1.265z" />
      <path d="m22.363 14.255-2.541-.389-1.144-2.436c-.247-.526-1.11-.526-1.357 0l-1.144 2.436-2.541.389c-.606.093-.848.83-.423 1.265l1.86 1.907-.44 2.702c-.101.617.557 1.081 1.103.777l2.264-1.251 2.264 1.251c.54.3 1.205-.154 1.103-.777l-.44-2.702 1.86-1.907c.424-.435.181-1.172-.424-1.265z" />
    </svg>
  ),
  "Pursuit of Purpose": (
    <svg height="16" viewBox="0 0 512 512" width="16" fill="#fff" xmlns="http://www.w3.org/2000/svg">
      <path d="m271.800781 176.558594c-5.113281-1.015625-10.394531-1.558594-15.800781-1.558594-44.664062 0-81 36.335938-81 81s36.335938 81 81 81 81-36.335938 81-81c0-5.40625-.542969-10.6875-1.558594-15.800781l-47.621094 47.621093c-8.5 8.5-19.800781 13.179688-31.820312 13.179688s-23.320312-4.679688-31.820312-13.179688-13.179688-19.800781-13.179688-31.820312 4.679688-23.320312 13.179688-31.820312zm0 0" />
      <path d="m489.089844 150.1875-32.273438 32.273438c-3.230468 3.230468-6.871094 5.910156-10.800781 7.988281 7.109375 20.558593 10.984375 42.609375 10.984375 65.550781 0 110.832031-90.167969 201-201 201s-201-90.167969-201-201 90.167969-201 201-201c22.949219 0 45.011719 3.878906 65.574219 10.992188 2.082031-3.933594 4.742187-7.589844 7.96875-10.8125l32.269531-32.269532c-32.269531-14.707031-68.097656-22.910156-105.8125-22.910156-141.160156 0-256 114.839844-256 256s114.839844 256 256 256 256-114.839844 256-256c0-37.714844-8.203125-73.542969-22.910156-105.8125zm0 0" />
      <path d="m319.710938 128.648438-2.734376-32.40625c-18.949218-7.261719-39.503906-11.242188-60.976562-11.242188-94.289062 0-171 76.710938-171 171s76.710938 171 171 171 171-76.710938 171-171c0-21.472656-3.980469-42.027344-11.242188-60.976562l-32.40625-2.734376-23.785156 23.78125c4.796875 12.398438 7.433594 25.859376 7.433594 39.929688 0 61.207031-49.792969 111-111 111s-111-49.792969-111-111 49.792969-111 111-111c14.070312 0 27.53125 2.636719 39.929688 7.433594zm0 0" />
      <path d="m346.410156 88.261719 4.367188 51.75-105.382813 105.382812c-5.859375 5.855469-5.859375 15.355469 0 21.210938 2.925781 2.929687 6.765625 4.394531 10.605469 4.394531s7.679688-1.464844 10.605469-4.394531l105.382812-105.382813 51.75 4.363282c.421875.035156.839844.054687 1.261719.054687 3.960938 0 7.78125-1.570313 10.605469-4.394531l63.636719-63.640625c4.128906-4.125 5.488281-10.273438 3.484374-15.757813-2.007812-5.484375-7.011718-9.304687-12.828124-9.792968l-46.070313-3.886719-3.882813-46.066407c-.492187-5.820312-4.3125-10.824218-9.792968-12.828124-5.484375-2.007813-11.632813-.644532-15.761719 3.480468l-63.636719 63.640625c-3.125 3.125-4.714844 7.464844-4.34375 11.867188zm0 0" />
    </svg>
  ),
  "Work-Life Fit": (
    <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" fill="#fff" viewBox="0 0 126.601 118.688">
      {" "}
      <path
        id="Path_39"
        data-name="Path 39"
        d="M120.834,45.05a3.709,3.709,0,0,0,4.115-6.172L102.695,24.042a3.71,3.71,0,0,0-4.115,0L76.326,38.878a3.709,3.709,0,0,0,4.115,6.172l1.652-1.1v16.56H78.383a3.709,3.709,0,0,0,0,7.418H96.928V79.054a3.713,3.713,0,0,1-3.709,3.709H73.789a11.125,11.125,0,0,0-20.978,0H33.628a3.713,3.713,0,0,1-3.709-3.709V67.927H48.464a3.709,3.709,0,0,0,3.709-3.709V34.546a3.709,3.709,0,0,0-3.709-3.709H37.337V27.128a11.127,11.127,0,1,0-22.254,0v3.709H3.709A3.709,3.709,0,0,0,0,34.546V64.218a3.709,3.709,0,0,0,3.709,3.709H22.5V79.054A11.14,11.14,0,0,0,33.628,90.181H52.811a11.18,11.18,0,0,0,6.78,6.78v15.474H48.464a18.566,18.566,0,0,0-18.545,18.545,3.709,3.709,0,0,0,3.709,3.709H92.972a3.709,3.709,0,0,0,3.709-3.709,18.566,18.566,0,0,0-18.545-18.545H67.009V96.961a11.18,11.18,0,0,0,6.78-6.78h19.43a11.14,11.14,0,0,0,11.127-11.127V67.927h18.545a3.709,3.709,0,1,0,0-7.418h-3.709V43.949ZM22.5,27.128a3.709,3.709,0,1,1,7.418,0v3.709H22.5ZM44.755,38.255v7.418H7.418V38.255ZM7.418,53.091H44.755v7.418H7.418Zm81.209,74.18H37.973a11.146,11.146,0,0,1,10.491-7.418H78.136A11.146,11.146,0,0,1,88.627,127.271ZM63.3,90.181a3.709,3.709,0,1,1,3.709-3.709A3.713,3.713,0,0,1,63.3,90.181ZM89.51,60.509V39l11.127-7.418L111.764,39V60.509Z"
        transform="translate(0 -16.001)"
      />
    </svg>
  ),
  "Analytical Reasoning": (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 36 36" fill="#fff">
      <path
        id="Icon_open-pie-chart"
        data-name="Icon open-pie-chart"
        d="M15.75,0A15.677,15.677,0,0,0,4.635,4.635L18,18V.135A18.316,18.316,0,0,0,15.75,0ZM22.5,4.77V20.115L10.26,32.355A15.69,15.69,0,1,0,22.5,4.77ZM4.095,10.665A13.247,13.247,0,0,0,5.22,30.78L14.8,21.195Z"
      />
    </svg>
  ),
  Courage: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" viewBox="0 0 52.493 51.461">
      <g id="sword" transform="translate(0 -5.033)">
        {" "}
        <path
          id="Path_634"
          data-name="Path 634"
          d="M18.087,394a8.9,8.9,0,0,1-.741-.845l-7.277,7.277,4.391,4.391,7.277-7.277a8.925,8.925,0,0,1-.845-.741Z"
          transform="translate(-9.037 -348.332)"
        />{" "}
        <path
          id="Path_635"
          data-name="Path 635"
          d="M392.511,393.159a8.906,8.906,0,0,1-.741.845l-2.806,2.806a8.926,8.926,0,0,1-.845.741l7.276,7.276,4.391-4.391Z"
          transform="translate(-348.328 -348.333)"
        />{" "}
        <path
          id="Path_636"
          data-name="Path 636"
          d="M277.785,296.051l.3.3a5.779,5.779,0,0,0,8.173,0l5-5a5.779,5.779,0,0,0,0-8.173l-.3-.3-3.3,3.293-3.717-3.717-6.586,6.586,3.717,3.717Z"
          transform="translate(-248.914 -248.983)"
        />{" "}
        <path
          id="Path_637"
          data-name="Path 637"
          d="M24.051,22.5,14.8,13.257A30.745,30.745,0,0,0,.52,5.17L0,5.04l.13.521A30.746,30.746,0,0,0,8.218,19.844l9.246,9.246Z"
          transform="translate(0 -0.006)"
        />{" "}
        <path
          id="Path_638"
          data-name="Path 638"
          d="M118.295,19.837a30.747,30.747,0,0,0,8.087-14.284l.13-.521-.521.13a30.746,30.746,0,0,0-14.284,8.087L87.766,37.193,84.473,33.9l-.3.3a5.779,5.779,0,0,0,0,8.173l5,5a5.779,5.779,0,0,0,8.173,0l.3-.3L94.353,43.78Z"
          transform="translate(-74.019)"
        />
      </g>
    </svg>
  ),
  "Diversity & Inclusion": (
    <svg id="community" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" viewBox="0 0 59.141 59.141">
      {" "}
      <path
        id="Path_639"
        data-name="Path 639"
        d="M316.377,97.68l-6.283,6.284a5.079,5.079,0,0,0-5.877.977,5.163,5.163,0,0,0-.977,5.878l-5.148,5.148,4.9,4.9.012-.013a5.2,5.2,0,1,1,7.35,7.352l-.012.012,6.035,6.036c4.135-6.595,6.42-10.247,6.423-18.287,0-10.638-6.069-17.584-6.423-18.287Z"
        transform="translate(-263.659 -86.397)"
        fill="#fff"
      />{" "}
      <path
        id="Path_640"
        data-name="Path 640"
        d="M18.543,126.994a5.163,5.163,0,0,0,.977-5.878l5.148-5.148-4.9-4.9-.012.013a5.2,5.2,0,1,1-7.35-7.352l.012-.012L6.383,97.68C2.247,104.275,0,107.927,0,115.967c0,10.638,6.029,17.584,6.383,18.287l6.283-6.284A5.079,5.079,0,0,0,18.543,126.994Z"
        transform="translate(0 -86.397)"
        fill="#fff"
      />{" "}
      <g id="Group_510" data-name="Group 510" transform="translate(11.263 0)">
        <path
          id="Path_641"
          data-name="Path 641"
          d="M127.8,310.418a5.079,5.079,0,0,0-.977-5.877,5.163,5.163,0,0,0-5.878-.977l-5.129-5.128-4.921,4.88.013.012a5.2,5.2,0,1,1-7.352,7.35l-.012-.012L97.508,316.7a34.925,34.925,0,0,0,7.5,4.228h0a29.664,29.664,0,0,0,10.808,2.174c10.616,0,17.562-6.048,18.268-6.4Z"
          transform="translate(-97.508 -263.963)"
          fill="#fff"
        />
        <path
          id="Path_642"
          data-name="Path 642"
          d="M274.268,316.7l-6.284-6.283a5.079,5.079,0,0,0-.977-5.877,5.163,5.163,0,0,0-5.879-.977L256,298.435V323.1C266.616,323.1,273.562,317.056,274.268,316.7Z"
          transform="translate(-237.693 -263.963)"
          fill="#fff"
        />
        <path
          id="Path_643"
          data-name="Path 643"
          d="M115.815,0c-10.638-.011-17.6,6.049-18.307,6.4l6.284,6.283a5.079,5.079,0,0,0,.977,5.877,5.163,5.163,0,0,0,5.879.977l5.168,5.128,4.881-4.88-.013-.012a5.2,5.2,0,1,1,7.352-7.35l.012.012L134.083,6.4C127.468,2.254,123.825.008,115.815,0Z"
          transform="translate(-97.508 0)"
          fill="#fff"
        />
        <path
          id="Path_644"
          data-name="Path 644"
          d="M260.868,19.776a5.2,5.2,0,1,1,7.352-7.35l.012.012L274.268,6.4C267.652,2.255,264.01.008,256,0V24.669l4.881-4.88Z"
          transform="translate(-237.693 0)"
          fill="#fff"
        />{" "}
      </g>
    </svg>
  ),
  Resourcefulness: (
    <svg id="settings" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" viewBox="0 0 88.099 88.099">
      <g id="Group_512" data-name="Group 512" transform="translate(0 0)">
        <g id="Group_511" data-name="Group 511">
          <path
            id="Path_645"
            data-name="Path 645"
            d="M54.061,6.683,51.52,1.427A2.582,2.582,0,0,0,49.212,0H38.888a2.582,2.582,0,0,0-2.309,1.427L34.036,6.683A38.488,38.488,0,0,0,23.9,11.013L19.653,8.891a2.571,2.571,0,0,0-2.979.484l-7.3,7.3a2.581,2.581,0,0,0-.484,2.979L11.013,23.9a38.488,38.488,0,0,0-4.33,10.138L1.426,36.579A2.583,2.583,0,0,0,0,38.888V49.212A2.582,2.582,0,0,0,1.427,51.52l5.259,2.543A38.3,38.3,0,0,0,8.624,59.5l1.928-3.852,5.756-5.756A28.316,28.316,0,0,1,49.891,16.308l8.27-8.27A38.852,38.852,0,0,0,54.061,6.683Z"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_514" data-name="Group 514" transform="translate(20.9 20.9)">
        <g id="Group_513" data-name="Group 513">
          <path
            id="Path_646"
            data-name="Path 646"
            d="M121.5,145.831,145.83,121.5A22.985,22.985,0,0,0,121.5,145.831Z"
            transform="translate(-121.463 -121.466)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_516" data-name="Group 516" transform="translate(42.835 42.833)">
        <g id="Group_515" data-name="Group 515">
          <path
            id="Path_647"
            data-name="Path 647"
            d="M273.274,248.932l-24.331,24.333A22.984,22.984,0,0,0,273.274,248.932Z"
            transform="translate(-248.943 -248.932)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_518" data-name="Group 518" transform="translate(28.602 29.924)">
        <g id="Group_517" data-name="Group 517">
          <path
            id="Path_648"
            data-name="Path 648"
            d="M223.956,180.426l-4.649-1.492a37.853,37.853,0,0,0-1.612-5.023l-8.283,8.284a28.315,28.315,0,0,1-33.58,33.583l-5.7,5.706-3.9,1.957a37.943,37.943,0,0,0,6.341,2.222l1.5,4.659a2.578,2.578,0,0,0,2.448,1.764h10.324a2.578,2.578,0,0,0,2.448-1.764l1.5-4.659A38.4,38.4,0,0,0,201,221.531l5.409,1.8a2.58,2.58,0,0,0,2.642-.623l7.3-7.3a2.58,2.58,0,0,0,.623-2.642l-1.8-5.409a38.4,38.4,0,0,0,4.131-10.218l4.659-1.5a2.578,2.578,0,0,0,1.764-2.447V182.873A2.578,2.578,0,0,0,223.956,180.426Z"
            transform="translate(-166.223 -173.91)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_520" data-name="Group 520" transform="translate(3.356 72.894)">
        <g id="Group_519" data-name="Group 519">
          <path
            id="Path_649"
            data-name="Path 649"
            d="M29.117,425.872a7.756,7.756,0,0,0-5.276-2.236l-4.053,8.1a2.581,2.581,0,0,0,3.464,3.463l8.093-4.053A7.694,7.694,0,0,0,29.117,425.872Z"
            transform="translate(-19.504 -423.637)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_522" data-name="Group 522" transform="translate(53.439 15.347)">
        <g id="Group_521" data-name="Group 521" transform="translate(0 0)">
          <rect
            id="Rectangle_826"
            data-name="Rectangle 826"
            width="6.669"
            height="20.646"
            transform="translate(0 4.716) rotate(-45)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_524" data-name="Group 524" transform="translate(61.804 0)">
        <g id="Group_523" data-name="Group 523">
          <path
            id="Path_650"
            data-name="Path 650"
            d="M382.449,2.9a10.647,10.647,0,0,0-14.6,0l-8.669,8.8,14.6,14.6,8.668-8.8A10.313,10.313,0,0,0,382.449,2.9Z"
            transform="translate(-359.181 0)"
            fill="#fff"
          />
        </g>
      </g>
      <g id="Group_526" data-name="Group 526" transform="translate(10.119 23.711)">
        <g id="Group_525" data-name="Group 525">
          <path
            id="Path_651"
            data-name="Path 651"
            d="M98.479,137.8,63.484,172.793l-4.674,9.342a12.6,12.6,0,0,1,9.975,9.905l9.326-4.671.025-.025L113.079,152.4Z"
            transform="translate(-58.81 -137.8)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  ),
  "Growth Mindset": (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#fff" viewBox="0 0 44.156 88.503">
      <g id="love-plant" transform="translate(-128.276 0.001)">
        <path
          id="Path_652"
          data-name="Path 652"
          d="M160.726,59.635A10.371,10.371,0,0,0,171.1,49.264H160.726a10.344,10.344,0,0,0-7.779,3.515V35.488L168.872,20.75a12.155,12.155,0,0,0,0-17.19h0a12.156,12.156,0,0,0-17.19,0l-1.327,1.327L149.027,3.56a12.156,12.156,0,0,0-17.19,0h0a12.156,12.156,0,0,0,0,17.19l15.925,14.738V63.15a10.344,10.344,0,0,0-7.779-3.515H129.612a10.371,10.371,0,0,0,10.371,10.371h7.779V88.5h5.186V80.378h7.779A10.371,10.371,0,0,0,171.1,70.007H160.726a10.344,10.344,0,0,0-7.779,3.515V59.635Z"
          transform="translate(0)"
          fill="#fff"
        />
      </g>
    </svg>
  )
};

// colors to identify the task by color
export const TaskTypeColors = {
  custom: "#AFBDFF",
  rating: "rgb(98, 121, 236)",
  learning: "#BC4B51",
  session: "#2196F3",
  mentor: "#2196F3",
  "Pending Task": "rgb(230, 57, 80)",
  "Completed Task": "rgb(0, 160, 133)",
  Pending: "rgb(230, 57, 80)",
  Completed: "rgb(0, 160, 133)",
  "Goal Setting": "rgb(45, 57, 88)",
  chemistry: "#f59e0b",
  "Team Sessions": "rgb(74, 101, 234)",
  "Session Rating": "rgb(98, 121, 236)",
  muted: "#9ca3af",
  "Chemistry Call": "#f59e0b",
  "Team session": "rgb(74, 101, 234)",
  "1:1 session": "rgb(98, 121, 236)",
  Mentoring: "#BC4B51"
};

export default {
  getFormattedTimeInHours,
  timeZoneOptions,
  colorPalette,
  formatDateTime_1,
  timeZoneOptionsTimeOnly,
  timeZoneOptionsMonthDayOnly
};

export const companyColorAccent = `${window.getComputedStyle(document.documentElement).getPropertyValue("--color-accent")}`.trim();

/** check if matches emails */
export const isMatchEmail = (value) => value.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);

export const isValidImage = (filename) => {
  const imageExtensions = ["png", "jpeg", "gif", "jpg"];
  const extension = filename.split(".").pop();

  if (!imageExtensions.includes(extension)) {
    Failure("Please select a valid image", "png, gif, jpeg");
    return false;
  }
  return true;
};

export const isValidCSV = (filename) => {
  const imageExtensions = ["csv"];
  const extension = filename.split(".").pop();

  if (!imageExtensions.includes(extension)) {
    Failure("Please upload a valid csv file.");
    return false;
  }
  return true;
};

export function isValidURL(string) {
  if (!string || string === "") return false;
  return isValidUrlString(string) && isValidUrlPattern(string);
}

const isValidUrlString = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

const isValidUrlPattern = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};
